import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 61043 61043"
    {...props}
  >
    <path
      d="M2090 2090h40139c9197 0 16723 7526 16723 16724v40138H18814c-9198 0-16724-7526-16724-16723V2090z"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 4180.99,
      }}
      className="stroke1"
    />
  </svg>
)
export default SvgComponent
